import imgAerra91 from "./img-aerra9 (1).webp";
import imgAerra92 from "./img-aerra9 (2).webp";

const imgAerra9 = [imgAerra91, imgAerra92];

export default imgAerra9;
